import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import LoadingSpinner from '../components/LoadingSpinner';
import api from "../api";

function SurveyCommentsInactive({ surveyId }) {
    const { t } = useTranslation();
    const [comments, setComments] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [loadingComments, setLoadingComments] = useState(false);
    const [error, setError] = useState(null);

    const totalPages = Math.ceil(totalCount / limit);

    const loadComments = async (pageNumber) => {
        setLoadingComments(true);
        setError(null);
        try {
            const response = await api.get(
                `${process.env.REACT_APP_API_URL}/api/survey/${surveyId}/comments?page=${pageNumber}&limit=${limit}`
            );
            setComments(response.data.comments);
            setTotalCount(response.data.count || 0);
        } catch (err) {
            setError(t('survey.errorFetchingComments'));
        } finally {
            setLoadingComments(false);
        }
    };

    useEffect(() => {
        if (surveyId) {
            setPage(1);
        }
    }, [surveyId]);

    useEffect(() => {
        if (surveyId) {
            loadComments(page);
        }
    }, [page, surveyId]);

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return '';
        const date = new Date(isoDate);
        return date.toLocaleDateString('en', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    return (
        <aside className="comments-page">
            <h2 className="comments-title">{t('survey.comments')}</h2>
            {error && <p className="error-message">{error}</p>}
            <div className="comments-list">
                {loadingComments ? (
                    <LoadingSpinner className="comments-loading-spinner"/>
                ) : comments.length > 0 ? (
                    comments.map((comment) => (
                        <div key={comment.id} className="comment-item">
                            <div className="comment-data">
                                <span className="comment-username">
                                    <Link className="comment-username" to={`/user/${comment.user_id}`}>{comment.username}</Link>
                                </span>
                                <span className="comment-date">{formatDate(comment.created_at)}</span>
                            </div>
                            <div className="comment-text">{comment.text}</div>
                            <div className="comment-actions-wrapper">
                                <span className="like-comment-button">
                                    <FontAwesomeIcon icon={faHeart} className="icon" />
                                    <span className="like-count">{comment.likes}</span>
                                </span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-comments">{t('survey.noComments')}</div>
                )}
            </div>
            {totalPages > 1 && !loadingComments && (
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={null}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel={null}
                    forcePage={page - 1}
                    containerClassName="pagination-container"
                    pageClassName="pagination-item"
                    pageLinkClassName="pagination-link"
                    previousClassName="pagination-item"
                    nextClassName="pagination-next"
                    previousLinkClassName="pagination-previous"
                    nextLinkClassName="pagination-link"
                    breakClassName="pagination-item"
                    breakLinkClassName="pagination-link"
                    activeClassName="active"
                />
            )}
        </aside>
    );
}

export default SurveyCommentsInactive;